module.exports = __webpack_public_path__ + "media/images/btn-fb-99065a4ae02b80f88d76b75f8e8cfde3.png";